import Overlay from "../../widgets/Tooltip";
import messageQuestion from "../../assets/images/message-question.png";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  selectPrice,
  selectRateCodes,
  selectSearchedPricesUtility,
  selectUtilities,
} from "../GetPrice/getPrice.selectors";
import { actions } from "../GetPrice/getPrice.slice";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCustomerInfo,
  selectSelectedSupplier,
} from "../PriceAndCustomerDetails";
import { selectFilters } from "../ShowPrices";
import { CLASS } from "../GetPrice";

export const ContactMeButton = ({ parent }) => {
  const { setContactMeData } = actions;
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  //TO-DO :- Check for commercial / residential  and Texas / Non-Texas

  // Show-Prices
  const basicInfo = useSelector(selectPrice);
  const residentialUtilities = useSelector(selectSearchedPricesUtility);
  const commercialUtilities = useSelector(selectUtilities);

  const loadZoneRateCodes = useSelector(selectRateCodes).map(
    (each) => each.LoadProfile
  );

  // Price Details
  const selectedSupplier = useSelector(selectSelectedSupplier);
  const filters = useSelector(selectFilters);

  // Account Information
  const customerInfo = useSelector(selectCustomerInfo);

  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <Overlay content={"Click here and an Energy Advisor will contact you"}>
      <Button
        variant={"outline-light"}
        className="query-info"
        onClick={(event) => {
          switch (parent) {
            case "ShowPrices":
              dispatch(
                setContactMeData({
                  class: basicInfo.class,
                  commodity: basicInfo.commodity,
                  zipCode: basicInfo.zipCode,
                  utility:
                    basicInfo.class === CLASS.RESIDENTIAL
                      ? residentialUtilities
                      : commercialUtilities,
                  loadZone: loadZoneRateCodes,
                })
              );
              break;
            case "PriceDetails":
              dispatch(
                setContactMeData({
                  class: basicInfo.class,
                  commodity: basicInfo.commodity,
                  annualUsage: basicInfo.usage,
                  monthlyBill: basicInfo.monthlyBill,
                  zipCode: basicInfo.zipCode,
                  utility:
                    basicInfo.class === CLASS.RESIDENTIAL
                      ? residentialUtilities
                      : commercialUtilities,
                  loadZone: loadZoneRateCodes,
                  LDCS: selectedSupplier.LDCId,
                  startDate: `${filters.year}-${months.indexOf(
                    filters.month
                  )}-01`,
                  supplierId: selectedSupplier.SupplierId,
                  supplierName: selectedSupplier.SupplierName,
                  productType: selectedSupplier.ProductType,
                  productName: selectedSupplier.ProductName,
                  planId: selectedSupplier.PlanId,
                  planName: selectedSupplier.PlanName,
                  price: selectedSupplier.Price,
                  class: basicInfo.class,
                  term: selectedSupplier.Term,
                  description: selectedSupplier.PlanDescription,
                })
              );
              break;
            case "AccountInformation":
              dispatch(
                setContactMeData({
                  annualUsage: basicInfo.usage,
                  monthlyBill: basicInfo.monthlyBill,
                  zipCode: basicInfo.zipCode,
                  utility:
                    basicInfo.class === CLASS.RESIDENTIAL
                      ? residentialUtilities
                      : commercialUtilities,
                  LDCS: selectedSupplier.LDCId,
                  LoadZone: loadZoneRateCodes,
                  startDate: `${filters.year}-${months.indexOf(
                    filters.month
                  )}-01`,
                  supplierId: selectedSupplier.SupplierId,
                  supplierName: selectedSupplier.SupplierName,
                  productType: selectedSupplier.ProductType,
                  productName: selectedSupplier.ProductName,
                  planId: selectedSupplier.PlanId,
                  planName: selectedSupplier.PlanName,
                  price: selectedSupplier.Price,
                  class: basicInfo.class,
                  term: selectedSupplier.Term,
                  description: selectedSupplier.PlanDescription,
                  contact: {
                    firstName: customerInfo.firstName,
                    lastName: customerInfo.lastName,
                    title: customerInfo.title,
                    email: customerInfo.email,
                    personalPhone: customerInfo.personalPhone,
                    workPhone: customerInfo.workPhone,
                    billingAddress: customerInfo.billingAddress,
                    customerLegalEntityName: customerInfo.customerInfo,
                  },
                })
              );
              break;
          }
          history.push("contact-me");
        }}
      >

        <img src={messageQuestion} x="0" y="0" height="25px" width="25px" />
        {/* <i className="icon-advanced"></i> */}
      </Button>
    </Overlay>
  );
};
